import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ServiceURLConstants } from '../constants/upplm.constants';
import { QVListRequest, QVListResponse } from '../interface/upplm.qvList';
import { UpplmApiService } from './upplm.api.services';
import { UpsCommonService } from './upplm.common.service';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()

export class QVDashboardSearchService {

    cardStatus: string = '';
    qvSearchRequest: QVListRequest = new QVListRequest;
    searchResults: QVListResponse = new QVListResponse;
    searchFlag: boolean = false;
    subject: Subject<Object> = new Subject<Object>();
    isListView: boolean = false;   

    constructor(private _apiService: UpplmApiService,
        private _commonService: UpsCommonService,
        private httpclient: HttpClient) {
    }

    getAllResults(): Observable<any> {
        return this.httpclient.post<any>(ServiceURLConstants.GET_QVLIST, JSON.stringify(this.qvSearchRequest), httpOptions);
    }
}